// extracted by mini-css-extract-plugin
module.exports = {"itemsTab":"ItemsTab_itemsTab__sTfJ2","errorView":"ItemsTab_errorView__2pO1F"};